<template>
  <div>
    <el-row>
      <div style="padding: 10px 25px">
        <el-form ref="form" :model="form" :inline="true" style="padding: 10px">
          <el-form-item>
            <el-input
              v-model="form.package_no"
              placeholder="包裹号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.goods_no"
              placeholder="货号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.goods_kh"
              placeholder="款号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.sku"
              placeholder="SKU编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="form.check_status"
              placeholder="商家核对状态"
              clearable
            >
              <el-option
                v-for="item in SEARCH_OPTIONS.CHECK_STATUS"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="form.check_result"
              placeholder="有无差异"
              clearable
            >
              <el-option
                v-for="item in SEARCH_OPTIONS.CHECK_RESULT"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label-width="0">
            <el-button type="primary" @click="handleSearch"> 查询 </el-button>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="success" @click="handleListExport"
              >导出列表
            </el-button>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="success" @click="handleLogExport">
              导出打标日志
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row>
      <div
        style="
          background: #f3f3f3;
          height: 50px;
          line-height: 50px;
          padding: 0 25px;
          display: flex;
          align-items: center;
        "
      >
        <div style="display: flex">
          <div style="width: 80px">数据汇总：</div>
          <div class="table-header">
            <div>一手入库：{{ totalData.in_num }}</div>
            <div>商家配货：{{ totalData.num }}</div>
            <div style="display: flex">
              入库差异：<NumColorCell
                :num="Number(totalData.in_feedback_num) || 0"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-table
          :key="'table1'"
          v-loading="tableLoading"
          :data="listData"
          border
          max-height="400px"
        >
          <el-table-column
            prop="img"
            label="商品图片"
            align="center"
            width="90"
          >
            <template #default="{ row }">
              <div
                v-viewer
                style="
                  width: 60px;
                  height: 60px;
                  overflow: hidden;
                  cursor: pointer;
                "
              >
                <img style="width: 100%; height: 100%" :src="row.main_img" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="goods_name"
            label="商品名称"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="goods_no"
            label="货号"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="goods_kh"
            label="款号"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column prop="sku" label="SKU" align="center" width="100">
          </el-table-column>
          <el-table-column
            prop="co_val"
            label="颜色"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="si_val"
            label="尺码"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="package_no"
            label="包裹号"
            align="center"
            width="120"
          >
          </el-table-column>

          <el-table-column
            prop="check_status_txt"
            label="商家核对状态"
            align="center"
            width="110"
          >
          </el-table-column>

          <el-table-column
            prop="check_result_txt"
            label="核对结果"
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column
            prop="in_num"
            label="一手入库数（当前实时）"
            align="center"
            width="120"
          >
            <template #default="{ row }">
              <div v-if="row.in_num">
                <div>{{ row.in_num }}</div>
              </div>
              <div v-else>0</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="商家配货数"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="check_goods_num" align="center">
            <div slot="header">
              <div>当前入库差异件数</div>
              <el-tooltip
                class="item"
                effect="dark"
                content="入库差异件数 = 一手已入库件数 - 商家配货件数"
                placement="top-start"
              >
                <i class="el-icon-question" />
              </el-tooltip>
            </div>
            <template #default="{ row }">
              <NumColorCell :num="row.in_feedback_num || ''" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right">
            <template #default="{ row }">
              <el-button type="text" @click="handleShowLog(row)"
                >查看打标日志</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="listData" style="text-align: right; padding: 25px">
        <el-pagination
          :current-page.sync="curPage"
          background
          layout="sizes,total, prev, pager, next,jumper "
          :total="count"
          :page-sizes="[5, 10, 20, 30, 50, 100]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import NumColorCell from "@//pages/receiveGoods/StockVarianceProcess/components/NumColorCell.vue";

import {
  postDetailPackageSkuList,
  postExporPackagetDaBiaoRecord,
} from "@/openapi/erp/supplyPackageCheckRecord.js";

const SEARCH_OPTIONS = {
  CHECK_STATUS: [
    {
      value: 1,
      label: "待核对",
    },
    {
      value: 2,
      label: "已核对",
    },
  ],
  CHECK_RESULT: [
    {
      value: 1,
      label: "有差异",
    },
    {
      value: 2,
      label: "无差异",
    },
  ],
  PACKGE_STATUS: [
    {
      value: 1,
      label: "待接收",
    },
    {
      value: 2,
      label: "已接收",
    },
    {
      value: 3,
      label: "已点货",
    },
  ],
};
const FETCH_TYPE_MAP = {
  exportList: "1",
  showList: "0",
};

export default {
  name: "InventoryByGoods",
  components: {
    NumColorCell,
  },
  props: {
    formProps: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      FETCH_TYPE_MAP,
      SEARCH_OPTIONS,
      tableLoading: false,
      curPage: 1,
      form: {
        package_no: "",
        goods_kh: "",
        goods_no: "",
        sku: "",
        check_status: "",
        check_result: "",
        package_time: this.formProps.package_time || "",
        supply_id: this.formProps.supply_id || "",
        package_type: this.formProps.package_type || "", // 包裹类型 "1"、大货 "2"、前置仓
        page: 1,
        page_size: 10,
      },
      resData: {},
      listData: [],
      totalData: {},
      count: 0, // 共多少条数据
    };
  },
  watch: {
    formProps: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.form.supply_id = newVal.supply_id || "";
        this.form.package_time = newVal.package_time || "";
        this.form.package_type = newVal.package_type || "";
        if (
          Boolean(this.form.supply_id) &&
          Boolean(this.form.package_time) &&
          Boolean(this.form.package_type)
        ) {
          this.fetchData("showList");
        }
      },
    },
  },
  created() {
    // this.fetchData("showList");
  },
  methods: {
    handleSizeChange(val) {
      this.form.page_size = val;
      this.fetchData("showList");
    },
    handleCurrentChange(page) {
      this.$set(this.form, "page", page);
      this.fetchData("showList");
    },
    async fetchData(fetchType) {
      try {
        if (fetchType === "exportList") {
          this.form.export = FETCH_TYPE_MAP[fetchType];
        } else {
          delete this.form.export;
        }
        const showLoading = fetchType === "showList";
        if (showLoading) {
          this.tableLoading = true;
        }
        const res = await postDetailPackageSkuList(this.form);
        if (showLoading) {
          this.resData = res;
          this.listData = res.list || [];
          if (this.form.page === 1) {
            this.totalData = res.statics || [];
          }
          this.count = res.count || 0;
          this.tableLoading = false;
        } else {
          window.open(apiBaseURL + res.file);
        }
      } catch (err) {
        console.log("postDetailPackageSkuList err: ", err);
        this.tableLoading = false;
      }
    },
    handleSearch() {
      this.fetchData("showList");
    },
    handleListExport() {
      this.fetchData("exportList");
    },
    async handleLogExport() {
      try {
        const { supply_id: supplyId, package_time: packageTime } = this.form;
        const params = { supply_id: supplyId, package_time: packageTime };
        const res = await postExporPackagetDaBiaoRecord(params);
        window.open(apiBaseURL + res.file);
      } catch (err) {
        console.log("postExporPackagetDaBiaoRecord err: ", err);
      }
    },
    handleShowLog(row) {
      this.$router.push(
        `/home/storage/markingloglist?package_no=${row.package_no}&sku=${row.sku}`
      );
    },
  },
};
</script>

<style scoped>
.table-header {
  width: 450px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/receiveGoods/StockVarianceProcess/components/InventoryByGoods.vue